import { formatCurrency } from "../../formatters/currency";
import { formatState } from "./helpers";
import { getCurrencyCookie } from "shared/utils/cookies";
import { applyVat } from "../apply-vat";

const pdf = require("pdfjs");
const HelveticaBold = require("pdfjs/font/Helvetica-Bold");

export const generateTable = (data, state, doc, t, shopifyPrices = {}) => {
  const currency = getCurrencyCookie();
  var table = doc.table({
    widths: [
      1 * pdf.cm,
      3 * pdf.cm,
      3.2 * pdf.cm,
      null,
      3 * pdf.cm,
      3 * pdf.cm,
    ],
    borderHorizontalWidths: function (i) {
      return i < 2 ? 1 : 0.1;
    },
    padding: 5,
  });

  var tr = table.header({ font: HelveticaBold, borderBottomWidth: 1.5 });
  tr.cell(t('pdf.columns.quantity'));
  tr.cell(t('pdf.columns.reference'));
  tr.cell(t('pdf.columns.eanCode'));
  tr.cell(t('pdf.columns.description'));
  tr.cell(t('pdf.columns.unitPrice'), { textAlign: "right" });
  tr.cell(t('pdf.columns.totalPrice'), { textAlign: "right" });

  function addRow({ quantity, ref, eanCode, desc, price, region, shopifyVariantId }) {
    var tr = table.row();
    tr.cell(quantity.toString());
    tr.cell("Ref: " + ref);
    tr.cell(eanCode);
    tr.cell(`${desc}${region ? ` - ${region.toUpperCase()}` : ''}`);
    const shopifyData = shopifyVariantId ? shopifyPrices[shopifyVariantId] : null;
    if (price === 0) {
      tr.cell('-', { textAlign: "right" });
      tr.cell('Included', {
        textAlign: "right",
      });
    } else if (shopifyData) {
      const unitPrice = parseFloat(shopifyData.amount);
      tr.cell(formatCurrency(unitPrice, shopifyData.currencyCode), { textAlign: "right" });
      tr.cell(formatCurrency(unitPrice * quantity, shopifyData.currencyCode), {
        textAlign: "right",
      });
    } else {
      tr.cell(formatCurrency(applyVat(price), currency), { textAlign: "right" });
      tr.cell(formatCurrency(applyVat(price * quantity), currency), {
        textAlign: "right",
      });
    }
  }
  const productLines = formatState(data, state);
  productLines.forEach(addRow);
  const shopifyEntries = Object.values(shopifyPrices);
  const shopifyCurrency = shopifyEntries.length > 0 ? shopifyEntries[0].currencyCode : null;
  const total = productLines.reduce((acc, item) => {
    const shopifyData = item.shopifyVariantId ? shopifyPrices[item.shopifyVariantId] : null;
    if (shopifyData) {
      return acc + parseFloat(shopifyData.amount) * item.quantity;
    }
    return acc + applyVat(item.price * item.quantity);
  }, 0);
  tr = table.row({
    font: HelveticaBold,
    borderBottomWidth: 0,
  });
  tr.cell("", { colspan: 5 });
  tr.cell(formatCurrency(total, shopifyCurrency || currency), { textAlign: "right" });
};
